// Helpdesk tickets: anyone raises one (from the app's Support tab or the
// office Helpdesk page); the helpdesk team (Helpdesk.Agent role, via the
// NU-Helpdesk group) works the queue.

export const TICKET_CATEGORIES = Object.freeze([
  { value: 'platform', label: 'Nano Utilities platform', hint: 'A screen not working, wrong information, an error message.' },
  { value: 'mobile_app', label: 'Mobile app', hint: 'The app on your phone: signing in, jobs, photos, notifications.' },
  { value: 'access_request', label: 'Access request', hint: 'Access to a screen, a SharePoint site, a form or another app.' },
  { value: 'general', label: 'General IT', hint: 'Your laptop, phone, email, Teams, anything else.' },
]);
export const TICKET_CATEGORY_LABEL = Object.freeze(Object.fromEntries(TICKET_CATEGORIES.map((c) => [c.value, c.label])));

export const TICKET_STATUSES = Object.freeze([
  { value: 'new', label: 'New' },
  { value: 'in_progress', label: 'In progress' },
  { value: 'waiting_on_user', label: 'Waiting on user' },
  { value: 'resolved', label: 'Resolved' },
]);
export const TICKET_STATUS_LABEL = Object.freeze(Object.fromEntries(TICKET_STATUSES.map((s) => [s.value, s.label])));
export const TICKET_OPEN = Object.freeze(['new', 'in_progress', 'waiting_on_user']);

// "Waiting on user" reads "Waiting on you" to the person who raised it.
export function ticketStatusLabel(status, { raiser = false } = {}) {
  if (status === 'waiting_on_user' && raiser) return 'Waiting on you';
  return TICKET_STATUS_LABEL[status] || status;
}

export const TICKET_PRIORITIES = Object.freeze([
  { value: 'low', label: 'Low' },
  { value: 'normal', label: 'Normal' },
  { value: 'high', label: 'High' },
  { value: 'urgent', label: 'Urgent' },
]);
export const TICKET_PRIORITY_LABEL = Object.freeze(Object.fromEntries(TICKET_PRIORITIES.map((p) => [p.value, p.label])));

export function ticketReference(n) {
  return `TKT-${String(n).padStart(6, '0')}`;
}

// Files on a ticket: photos and screenshots (shrunk to JPEG on the device)
// and, from a computer, PNG or PDF.
export const TICKET_FILE_TYPES = Object.freeze(['image/jpeg', 'image/png', 'application/pdf']);
export const TICKET_FILE_MAX_BYTES = 8 * 1024 * 1024;
